import API from "../lib/api";

export const getRewardPointSettingsApi = async (restaurantId) => {
  try {
    const response = await API.get(`/restaurant/${restaurantId}/reward-point-settings`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateRewardPointSettingsApi = async (restaurantId, data) => {
  try {
    const response = await API.put(`/restaurant/${restaurantId}/reward-point-settings`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
